var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container feedback template-bg-gray",
      class: { "my-position-relative": _vm.isStatus }
    },
    [
      _vm.isStatus
        ? _c(
            "md-card",
            {
              staticClass:
                "request-status loop_container bg-transparent update-request-form-common"
            },
            [
              _c(
                "md-card-content",
                { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main" },
                [
                  _c(
                    "div",
                    { staticClass: "card form-wrapper text-center p-20" },
                    [
                      _c("h4", {
                        staticClass: "template-custom-title",
                        domProps: { innerHTML: _vm._s(_vm.statusMsg) }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isStatus
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "loop_container bg-transparent update-request-form-common"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "card form-wrapper thankupageplr88" },
                      [
                        _c("div", { staticClass: "feedback_container" }, [
                          _vm.logoURL
                            ? _c("div", { staticClass: "community-logo" }, [
                                _c("img", {
                                  staticClass: "top-logo custom-logo",
                                  attrs: { src: _vm.logoURL, alt: _vm.imgAlt }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "header-text text-center common-space-from-logo"
                            },
                            [
                              _c(
                                "h1",
                                {
                                  staticClass: "template-title",
                                  attrs: {
                                    role: "alert",
                                    "aria-live": "assertive"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.message))]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "custome-width-500 plr10"
                              })
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "list-inline text-center footer-links" },
                      [
                        _c("li", [
                          _vm.community.content &&
                          _vm.community.content.landingPageURL &&
                          _vm.community.content.landingPageURL.length
                            ? _c(
                                "a",
                                {
                                  staticClass: "links",
                                  attrs: {
                                    href: _vm.community.content.landingPageURL,
                                    target: "_blank",
                                    tabindex: "0"
                                  }
                                },
                                [_vm._v("Learn More")]
                              )
                            : _c(
                                "a",
                                {
                                  attrs: {
                                    href: "javascript:void(0)",
                                    tabindex: "0"
                                  }
                                },
                                [_vm._v("Learn More")]
                              )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm.community.content &&
                          _vm.community.content.termsConditionsURL &&
                          _vm.community.content.termsConditionsURL.length
                            ? _c(
                                "a",
                                {
                                  staticClass: "links",
                                  attrs: {
                                    href:
                                      _vm.community.content.termsConditionsURL,
                                    target: "_blank",
                                    tabindex: "0"
                                  }
                                },
                                [_vm._v("Terms Of Use [pdf]")]
                              )
                            : _c(
                                "a",
                                {
                                  attrs: {
                                    href: "javascript:void(0)",
                                    tabindex: "0"
                                  }
                                },
                                [_vm._v("Terms Of Use [pdf]")]
                              )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm.community.content &&
                          _vm.community.content.unsubscribePageURL &&
                          _vm.community.content.unsubscribePageURL.length
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    tabindex: "0",
                                    href:
                                      _vm.community.content.unsubscribePageURL,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("Opt Out")]
                              )
                            : _c(
                                "a",
                                { attrs: { href: "javascript:void(0)" } },
                                [_vm._v("Opt Out")]
                              )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "unsubscribe-community-logo" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://www.protopia.co",
                            target: "_blank"
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: this.footerLogoURL,
                              alt: "Community Logo"
                            }
                          })
                        ]
                      )
                    ])
                  ]
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43a216f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43a216f5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/requestSnooze.vue
// module id = null
// module chunks = 